const SKIN_TYPES = {
  OILY: 'Oily',
  DRY: 'Dry',
  NORMAL_TO_OILY: 'Normal to Oily',
  NORMAL_TO_DRY: 'Normal to Dry',
  NORMAL: 'Normal',
  SENSITIVE: 'Sensitive',
  NOT_SENSITIVE: 'Not sensitive',
};

export default SKIN_TYPES;
